import styled, { css } from 'styled-components/macro';

export const Container = styled.div`
  bottom: 0;
  display: flex;
  font-family: Roboto, Arial, sans-serif;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 101;
`;
export const Wrapper = styled.div`
  display:flex;
  position: relative;
  width: calc(100% - 30px);
  background: #fff;
  border-radius: 15px 15px 0 0;
  box-shadow: 0 -2px 20px rgba(0, 0, 0, .15);
  box-sizing: border-box;
  opacity: 1;
  transition: opacity .3s ease-in-out;
  padding: 10px 12px 7px;
  align-items: center;
  flex-direction: column;
  max-width: 560px;
`;
export const Text = styled.p`
  color: #888;
  font-size: 10px;
  margin: 0;
  a,
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: #348cdd
  }
`;
export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 12px;
  flex: 0 0;
  margin-top: 10px;
`;
const btn = css`
  flex: 1 0;
  border-radius: 24px;
  background: #fff;
  border: 1px solid #888;
  max-width: 160px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #888;
  cursor: pointer;
`;
const btnAccept = css`
  background: #888;
  color: #fff;
`;
const btnReject = css`
  background: #fff;
  color: #888;
`;

export const Button = styled.button<{ $reject?: boolean }>`
  ${btn};
  ${({ $reject }) => ($reject ? btnReject : btnAccept)}
`;
